import { render, staticRenderFns } from "./DrugAlerts.vue?vue&type=template&id=46ada40c"
import script from "./DrugAlerts.vue?vue&type=script&lang=js"
export * from "./DrugAlerts.vue?vue&type=script&lang=js"
import style0 from "./DrugAlerts.vue?vue&type=style&index=0&id=46ada40c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports